export default function LockIcon() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Lock Icon</title>
      <path
        d="M8 0C5.00571 0 2.57143 2.43429 2.57143 5.42857V6.90571L2.35714 6.96C0.968571 7.32 0 8.56857 0 10V14.5714C0 16.3057 1.40857 17.7143 3.14286 17.7143H12.8571C14.5914 17.7143 16 16.3057 16 14.5714V10C16 8.56857 15.0314 7.32 13.6429 6.96L13.4286 6.90571V5.42857C13.4286 2.43429 10.9943 0 8 0ZM4.28571 5.42857C4.28571 3.38 5.95143 1.71429 8 1.71429C10.0486 1.71429 11.7143 3.38 11.7143 5.42857V6.85714H4.28571V5.42857ZM14.2857 10V14.5714C14.2857 15.36 13.6457 16 12.8571 16H3.14286C2.35429 16 1.71429 15.36 1.71429 14.5714V10C1.71429 9.21143 2.35429 8.57143 3.14286 8.57143H12.8571C13.6457 8.57143 14.2857 9.21143 14.2857 10Z"
        fill="#FBFBFB"
      />
      <path
        d="M8.00088 13.1425C8.47427 13.1425 8.85802 12.7588 8.85802 12.2854C8.85802 11.812 8.47427 11.4282 8.00088 11.4282C7.52749 11.4282 7.14374 11.812 7.14374 12.2854C7.14374 12.7588 7.52749 13.1425 8.00088 13.1425Z"
        fill="#FBFBFB"
      />
    </svg>
  );
}
